<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow" nav_title="工作经历"/>
    <w-cv-form :form-list="workForm" :req="formData"/>
    <div class="online-footer footer">
      <button class="theme-button flex-center footer-button" :class="{'disable-button': disableState}"
              @click="saveInfo">保存
      </button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import WCvForm from '@/components/cv/w-cv-form'
	import { mapActions, mapGetters, mapState } from 'vuex'
	import { verifyRequired, deleteRedundancy } from '../../assets/js/utils'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { eventMixin } from '@/assets/js/mixin/global'

	import { workForm } from '@/assets/json/online-cv'
	import { envMixin } from '../../assets/js/mixin/global'

	const moment = require('moment')

	export default {
		name: 'work-info',
		mixins: [ componentsMixin, eventMixin, envMixin ],
		data () {
			return {
				workForm,
				formData: {},
				hasWork: true
			}
		},
		async mounted () {
			await this.iosBridgeGet()
			this._initFormData()
		},
		computed: {
			...mapGetters('cv', [ 'workFullInfo' ]),
			...mapState('cv', [ 'cv' ]),
			requiredField () {
				return [
					{ val: this.formData.company, message: '请填写公司名称' },
					{ val: this.formData.title, message: '请填写职位名称' },
					{ val: this.formData.start_at, message: '请选择开始时间' },
					{ val: this.formData.end_at || this.formData.present, message: '请选择结束时间' }
				]
			},
			disableState () {
				return verifyRequired(this.requiredField)
			}
		},
		watch: {},
		components: {
			WNavBar,
			WCvForm
		},
		methods: {
			...mapActions('cv', [ 'updateModuleInfo', 'createModuleInfo', 'updateCvDetail' ]),
			async saveInfo () {
				let { online_token } = this.$route.params
				let { sections_position } = this.cv.submodule_info
				const index = sections_position.findIndex(item => item.type === 'works')
				if (verifyRequired(this.requiredField)) {
					this.showToast(verifyRequired(this.requiredField), 2000)
					return
				}
				let payload = {
					cv_token: this.$route.params.online_token,
					...deleteRedundancy(this.formData)
				}
				if (payload.end_at === '至今' || payload.end_at === 'Present') {
					payload.present = payload.end_at
					payload.end_at = null
				} else if (payload.end_at) {
					payload.present = null
				}
				payload.start_at = payload.start_at ? moment.utc(payload.start_at) : null
				payload.end_at = payload.end_at ? moment.utc(payload.end_at) : null
				payload.lang = 'cn'
				let position = sections_position
				if (index === -1) {
					position = [ ...sections_position, { id: null, type: 'works', info_ids: [] } ]
				}
				if (this.formData.id && payload.kind !== 'sample') {
					await this.updateModuleInfo({
						id: payload.id,
						payload,
						moduleName: 'works'
					})
					await this.updateCvDetail({
						token: online_token,
						payload: {
							operation_type: 'update_submodule_info',
							submodule_info: {
								sections_position: position
							}
						}
					})
          this.$router.back()
				} else {
					let data = await this.createModuleInfo({ payload, type: 'works' })
					if (data === 80143)  {
						this.showAlert('每个模块最多添加30段经历<br>请删除多余经历后重试', '我知道了')
            return
					}
					await this.updateCvDetail({
						token: online_token, payload: {
							operation_type: 'update_submodule_info',
							submodule_info: {
								works_ids: [ data.works.id ],
                sections_position: position
							}
						}
					})
					this.$router.back()
				}
			},
			_initFormData () {
				window.scrollTo(0, 0)
				if (this.workFullInfo && this.workFullInfo.length) {
					this.formData = this.workFullInfo[0]
					this.formData.start_at = this.formData.start_at ? moment(this.formData.start_at).format('YYYY-MM') : null
					this.formData.end_at = this.formData.end_at ? moment(this.formData.end_at).format('YYYY-MM') : null
				} else {
					this.hasWork = false
					this.formData = {
						company: '',
						title: '',
						start_at: '',
						end_at: ''
					}
				}
			},
			routerBack () {
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .list {
    /deep/ .date-time-link {
      border-top: none;
    }
  }
</style>
